// Flip to false to show every team headshot in full color at all times.
// When true, headshots render black & white by default; ones with a
// bio_slug (a real bio page) go full color on hover.
export const GRAYSCALE_HEADSHOTS = false;

// Flip to true to show the "Where We Build" state-abbreviation card pinned
// to the bottom-right corner of the Home hero (see HomeStatesHighlight.js).
// Disabled for now at the user's request.
export const SHOW_HOME_STATES_HIGHLIGHT = false;
